import produce, { castDraft, } from 'immer';
import { DeviceClassesActionType, } from './actions';
const deviceClassesByProjectIdByIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case DeviceClassesActionType.SET_DEVICE_CLASSES:
            return produce(currentState, (draft) => {
                const { projectId, classes } = action;
                const temp = draft[projectId] || {};
                draft[projectId] = temp;
                classes.forEach((deviceClass) => {
                    temp[deviceClass.id] = (deviceClass);
                });
            });
        default:
            return currentState;
    }
};
const allDeviceClassIdsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case DeviceClassesActionType.SET_DEVICE_CLASSES:
            return produce(currentState, () => {
                const actualAction = action;
                // convert the list of actualAction.classes to an Array of device class ids and update the currentState with the new
                // list. NOTE: only need to update the currentState if NOT both of them are empty. If both of them are empty,
                // do not need to run this or else it will replace the currentState with a NEW empty array which cause unnecessary
                // UI re-render.
                if (actualAction.classes.length !== 0 || !currentState || currentState.length !== 0) {
                    return actualAction.classes.map((deviceClass) => {
                        return deviceClass.id;
                    });
                }
                return currentState;
            });
        default:
            return currentState;
    }
};
const deviceClassIdsByProjectIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case DeviceClassesActionType.SET_DEVICE_CLASSES:
            return produce(currentState, (draft) => {
                const { projectId } = action;
                draft[projectId] = castDraft(allDeviceClassIdsReducer(currentState[projectId], action));
            });
        default:
            return currentState;
    }
};
export const deviceClassesStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.deviceClassesByProjectIdById = deviceClassesByProjectIdByIdReducer(currentState.deviceClassesByProjectIdById, action);
        draft.deviceClassIdsByProjectId = castDraft(deviceClassIdsByProjectIdReducer(currentState.deviceClassIdsByProjectId, action));
    });
};
